export const COOKIES_CONSENT_KEY = 'cookies_consent';

export enum COOKIES_CONSENT_ALIASES {
  YES = 'YES',
  NO = 'NO',
}
